import React from "react";
import { useSelector } from "react-redux";
import { withRouter } from "react-router-dom";

import { useTranslation } from "react-i18next";

import { Button } from "@material-ui/core";
import PhoneIcon from '@material-ui/icons/Phone';
import GoogleIcon from '@mui/icons-material/Google';
import useStyles from "./styles";
import checkoutServices from "~/services/checkoutServices";
import { getAuth, GoogleAuthProvider, signInWithPopup } from "firebase/auth";
import Utils from "~/helpers/Utils";

function ButtonsLogin(props) {
	const { t } = useTranslation();
    const { user } = useSelector((store) => store.auth);
	const { me } = useSelector((store) => store.me);
	const { business: businessStore } = useSelector((store) => store.business);
	const { selectedPackage, goBackRouteProps, goBackRoute = '/packages/' } = props;

	const business = Utils.safeParseJSON("@prit-web/business", businessStore);

	// Salva o pacote selecionado no localStorage quando o componente é montado
	React.useEffect(() => {
		if (selectedPackage) {
			localStorage.setItem("@prit-web/selectedPackage", JSON.stringify(selectedPackage));
		}
	}, [selectedPackage]);

	const provider = new GoogleAuthProvider();
	const auth = getAuth();

	const login = async () => {
		try {
			await signInWithPopup(auth, provider);

			const res = await checkoutServices.me();

			if (res?.data?.id) {
				localStorage.setItem("@prit-web/meData", JSON.stringify(res.data));
				localStorage.setItem("@prit-web/userId", res.data.id);

				if (!res.data.phoneUnverified) {
					props.history.replace("/login/personal-information-number", {
						logEventFor: "Google",
						goBackRoute: `${goBackRoute}${business?.id}`,
						goBackRouteProps: goBackRouteProps || props.location.state,
					});
				} else {
					window.location.reload();
				}
			}
		} catch (error) {
			alert(`Erro durante o login com Google: ${error.message}`);
		}
	};

    const classes = useStyles();

	return (
		<div style={{ width: "100%", justifyContent: "center", display: "grid" }}>
							{process.env.REACT_APP_GOOGLE_LOGIN_ENABLED === "true" && !me?.name && (
								<Button
									className={classes.root}
									style={{
										textTransform: "uppercase",
										fontWeight: "Bold",
										marginBottom: "5%",
									}}
									onClick={() => login()}
                                    >
									<GoogleIcon style={{ position: "absolute", left: 16 }} />
									<span style={{ flexGrow: 1, textAlign: "center" }}>{t("Continue Google")}</span>
								</Button>
							)}
							<Button
								type="button"
								onClick={() => {
									if (!me || !me?.name || (!me?.phone && !me?.phoneUnverified) || !user || user.isAnonymous) {
										props.history.push(`/business/link/${business.id}`, {
											goBackRoute: `/packages/${business?.id}`,
											goBackRouteProps: goBackRouteProps || props.location.state,
										});
									} 
								}}
								className={classes.root}
								style={{
									textTransform: "uppercase",
									fontWeight: "Bold",
									backgroundColor: me?.name ? "#440067" : "#fff",
									border: "2px solid #440067",
									color: me?.name ? "#fff" : "#440067",
								}}>
								<PhoneIcon style={{ position: "absolute", left: 16 }} />
								{t("Continue")}
							</Button>
						</div>
	);
}

export default withRouter(ButtonsLogin);